import { Box, Link } from "@mui/material";
import MaterialTable from "material-table";
import React, { useState } from "react";
import ReviewForm from "../ReviewForm";
import { ConvertDate } from "../../../../Base/helper/baseFunctions";

const MyReporteesTR = () => {
    const [openReviewForm, setOpenReviewForm] = useState(false);
    const [currentStage, setCurrentStage] = useState(0);
    console.log("openReview", openReviewForm)
  return (
    <Box pt={1.5}>
     { !openReviewForm ? (
      <MaterialTable
        columns={[
          {
            title: "Title",
            field: "title",
            render: (rowData) => (
              <Link
                href="#"
                underline="hover"
                color="primary"
                onClick={(e) => {
                  e.preventDefault();
                  // 👇 Handle click event here
                  setOpenReviewForm(true);
                  setCurrentStage(rowData?.currentStep)
                  console.log("Clicked:", rowData.title);
                }}
              >
                {rowData.title}
              </Link>
            ),
          },
          { title: "Employee", field: "employee" },
          { title: "Status", field: "status" },
          { title: "Completed On", field: "completedOn", render: (rowData) => ConvertDate(rowData?.completedOn) },
        ]}
        data={reviewData}
        options={{
          maxBodyHeight: "calc(100vh - 280px)",
          minBodyHeight: "calc(100vh - 280px)",
          rowStyle: {
            fontSize: "13px",
            height: "35px",
          },
          cellStyle: {
            padding: "5px 0px 5px 13px",
          },
          headerStyle: {
            padding: "5px 10px 5px 10px",
            fontWeight: "bold",
          },
          sorting: true,
          search: true,
          searchText: "",
          searchFieldAlignment: "right",
          searchAutoFocus: false,
          searchFieldVariant: "standard",
          filtering: false,
          paging: true,
          pageSizeOptions: [25, 50],
          pageSize: 25,
          paginationType: "stepped",
          showFirstLastPageButtons: false,
          paginationPosition: "bottom",
          exportButton: false,
          exportAllData: false,
          exportFileName: "Employees",
          addRowPosition: "first",
          selection: false,
          actionsColumnIndex: -1,
          grouping: false,
          columnsButton: false,
        }}
        title={""}
      /> )
      : (
      <ReviewForm setOpenReviewForm={setOpenReviewForm} currentStep={currentStage}/>
      )}  
    </Box>
  );
};

const reviewData = [
  {
    title: "Review Form 2025",
    employee: "Emp1",
    status: "Manager Review",
    completedOn: "",
    currentStep: 1
  },
  {
    title: "Review Form 2025",
    employee: "Emp22",
    status: "HR Review",
    completedOn: "", 
    currentStep: 2
  },
  {
    title: "Review Form 2024",
    employee: "Emp112",
    status: "Review Closed",
    completedOn: "2024-12-25",
    currentStep: 3
  },
  {
    title: "Review Form 2024",
    employee: "Emp2",
    status: "Review Closed",
    completedOn: "2024-12-15",
    currentStep: 3
  },
];

export default MyReporteesTR;
